
/*
 * Инициализация .js-image-with-text-slider переехала в
 * sections/section-image-with-text-slider.liquid — вместе с ней Swiper грузится
 * только на страницах с этой секцией, а не на всём сайте.
 */

let imageWithProducts = document.querySelectorAll('.js-image-with-products');
if(imageWithProducts){
    imageWithProducts.forEach(function (section){
        let hoverElements = section.querySelectorAll('[data-hover-element]');
        hoverElements.forEach(function (element){
            element.addEventListener('mouseenter',function (){
                let elementId = this.dataset.id;
                document.querySelectorAll(`[data-hover-element][data-id="${elementId}"]`).forEach(link=>{
                    link.classList.add('active')
                })
            })
        })
        hoverElements.forEach(function (element){
            element.addEventListener('mouseleave',function (){
                let elementId = this.dataset.id;
                document.querySelectorAll(`[data-hover-element][data-id="${elementId}"]`).forEach(link=>{
                    link.classList.remove('active')
                })
            })
        })
    })
}